export default "__VITE_ASSET__4LEsKozS__"